export const getFingerprint = (): string | undefined => {
  const fingerprint = document.querySelector(
    '#fingerprint',
  ) as HTMLInputElement;

  return fingerprint?.value && fingerprint.value.length > 0
    ? fingerprint.value
    : undefined;
};
